import { render, staticRenderFns } from "./eyca-sync-btn.vue?vue&type=template&id=15be31d0"
import script from "./eyca-sync-btn.vue?vue&type=script&lang=js"
export * from "./eyca-sync-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports